import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=7b9f122e&"
import script from "./FormGroup.vue?vue&type=script&lang=ts&"
export * from "./FormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports